import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import cafe from "../../static/images/cafe_las_flores.png";
import defaultLogo from "../../static/images/rsz_real-estate-building-logo-icon-vector.jpg";

const BusquedaEmpleos = () => {
  const [filtersearch, setFilterSearch] = useState({
    companyName: null,
    departamentoId: [],
    fechaPublicacion: 0,
    sector: null,
    tipoContradoId: [],
    tipoEmpleoId: [2],
    tipoJornadaId: [],
  });
  let history = useHistory();
  let location = useLocation();

  const [sending, setSending] = useState(false);
  const [applicant, setapplicant] = useState("");
  // const [data, setData] = useState("");

  const [listempleos, setlistEmpleos] = useState([]);
  const [departmentList, setdepartmentList] = useState([]);
  const [tipojornadaList, settipojornadaList] = useState([]);
  const [listContracts, setlistContracts] = useState([]);
  const [tipoempleoList, settipoempleoList] = useState([]);

  const [flagshowDepartamento, setflagshowDepartamento] = useState(false);
  const [flagshowJornada, setflagshowJornada] = useState(false);
  const [flagshowContrato, setflagshowContrato] = useState(false);
  const [flagshowEmpleo, setflagshowEmpleo] = useState(false);

  const [flag, setflag] = useState(false);

  const [fechaSelected, setfechaSelected] = useState("");
  const [departSelected, setdepartSelected] = useState([]);
  const [jornadaSelected, setjornadaSelected] = useState([]);

  const config = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
  };

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(text) {
    text = window.location.href
      .toString()
      .replace("#", "")
      .replace("/user/BusquedaEmpleos", text);
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        toast.success("Enlace de la vacante fue copiado al portapapeles", {
          duration: 4000,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  useEffect(() => {
    const getDepartamento = async () => {
      await axios.get("department-list").then((result) => {
        if (result.status === 200) {
          setdepartmentList(result.data);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };
    const LoadTipoJornada = async () => {
      await axios.get("tipo-jornada/list", config).then((result) => {
        settipojornadaList(result.data);
      });
    };
    function ListContratos() {
      axios.get("contract/list-contracts").then((result) => {
        setlistContracts(result.data);
        // setLoading(false);
      });
    }
    const LoadTipoEmpleo = async () => {
      axios.get("tipo-empleo/list", config).then((result) => {
        settipoempleoList(result.data);
      });
    };
    ListBusquedaEmpleo();
    getDepartamento();
    LoadTipoJornada();
    ListContratos();
    LoadTipoEmpleo();
  }, [flag, filtersearch]);

  const ListBusquedaEmpleo = () => {
    axios
      .post("/access/buscar-vacante", filtersearch)
      .then((result) => {
        setlistEmpleos(result.data);
        // setLoading(false);
      })
      .catch(function (error) {
        //setLoading(true);
        if (!error.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        } else if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else if (error.request) {
        }
      });
  };

  const handleChangeFechaPublicacion = (e) => {
    setfechaSelected(e.target.value);
    setFilterSearch({ ...filtersearch, fechaPublicacion: e.target.value });
    ListBusquedaEmpleo();
  };

  const handleChangeCategoria = (e) => {
    setFilterSearch({ ...filtersearch, sector: e.target.value });
    //ListBusquedaEmpleo();
  };
  const handleChangeEmpresa = (e) => {
    if (e.target.value !== "") {
      setFilterSearch({ ...filtersearch, companyName: e.target.value });
    } else {
      // console.log(2);
      setFilterSearch({ ...filtersearch, companyName: null });
    }
    //ListBusquedaEmpleo();
  };

  const handleDepartChange = (id) => {
    let data = departSelected;

    let filter = data.find((x) => x === id);
    if (filter === undefined) {
      setdepartSelected([...data, id]);
      setFilterSearch({ ...filtersearch, departamentoId: [...data, id] });
    } else {
      let indice = data.indexOf(id);
      data.splice(indice, 1);
      setdepartSelected(data);
      setFilterSearch({ ...filtersearch, departamentoId: data });
    }
  };

  const handleJornadaChange = (id) => {
    let data = jornadaSelected;

    let filter = data.find((x) => x === id);
    if (filter === undefined) {
      setjornadaSelected([...data, id]);
      setFilterSearch({ ...filtersearch, tipoJornadaId: [...data, id] });
    } else {
      let indice = data.indexOf(id);
      data.splice(indice, 1);
      setjornadaSelected(data);
      setFilterSearch({ ...filtersearch, tipoJornadaId: data });
    }
  };

  const handleContratoChange = (id) => {
    let data = filtersearch.tipoContradoId;

    let filter = data.find((x) => x === id);
    if (filter === undefined) {
      setjornadaSelected([...data, id]);
      setFilterSearch({ ...filtersearch, tipoContradoId: [...data, id] });
    } else {
      let indice = data.indexOf(id);
      data.splice(indice, 1);
      setjornadaSelected(data);
      setFilterSearch({ ...filtersearch, tipoContradoId: data });
    }
  };

  const handleEmpleoChange = (id) => {
    let data = filtersearch.tipoEmpleoId;

    let filter = data.find((x) => x === id);
    if (filter === undefined) {
      setjornadaSelected([...data, id]);
      setFilterSearch({ ...filtersearch, tipoEmpleoId: [...data, id] });
    } else {
      let indice = data.indexOf(id);
      data.splice(indice, 1);
      setjornadaSelected(data);
      setFilterSearch({ ...filtersearch, tipoEmpleoId: data });
    }
  };
  function VerDepartamento(flag) {
    setflagshowDepartamento(flag);
  }
  function BuscarEmpleocheck(id) {
    var select = filtersearch.tipoEmpleoId.find((i) => i === id);
    if (select === undefined) {
      return false;
    }

    return true;
  }
  function CleanFilterEmpleo() {
    setFilterSearch({ ...filtersearch, tipoEmpleoId: [] });
    BuscarEmpleocheck();
  }
  function handleChangeEmpleo(e) {
    alert(e.target.checked);
    let isChecked = e.target.checked;
    // do whatever you want with isChecked value
  }

  function VerDepartamento(flag) {
    setflagshowDepartamento(flag);
  }
  function BuscarEmpleocheck(id) {
    var select = filtersearch.tipoEmpleoId.find((i) => i === id);
    if (select === undefined) {
      return false;
    }

    return true;
  }
  const aplicarVacante = (companyvacantID) => {
    setSending(true);
    const res = axios.post("/company-vacant/apply-vacant", {
      aplicarVacanteId: 0,
      fechaAplicacion: new Date(),
      habilidades: "string",
      insignia: 0,
      test: false,
      applicantProfileId: localStorage.getItem("applicantId"),
      vacanteEmpresaId: companyvacantID,
    });
    sendMail(companyvacantID);
    setSending(false);
  };
  const sendMail = (companyvacantID) => {
    const res = axios.post("access/notification-vacant/" + companyvacantID);
  };
  const h = {
    textAlign: "center",
  };

  const redirectVacante = (id) => {
    history.push("/user/Vacante/" + id);
  };

  return (
    <section className="busquedaAvanzada">
      <div className="container">
        <div className="row align-items-center pt-4 pb-4">
          <div className="col-3">
            <h5>Resúmen de tu busqueda:</h5>
          </div>
          <div className="col-6"></div>
          <div className="col-3">
            <div className="row rightBox"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="box p-5">
              <div className="text mb-4">Filtro de Búsqueda</div>
              <hr></hr>
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Categoría
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fas fa-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Categoria"
                    aria-label="Categoria"
                    aria-describedby="basic-addon1"
                    onChange={(e) => {
                      handleChangeCategoria(e);
                    }}
                  ></input>
                </div>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Empresa
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fas fa-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Empresa"
                    aria-label="Empresa"
                    aria-describedby="basic-addon1"
                    onChange={(e) => {
                      handleChangeEmpresa(e);
                    }}
                  ></input>
                </div>
              </div>
              <hr></hr>
              <div className="accordion" id="accordionFechaPublicacion">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFechaPublicacion"
                      aria-expanded="true"
                      aria-controls="collapseFechaPublicacion"
                    >
                      Fecha de Publicación
                    </button>
                  </h2>
                  <div
                    id="collapseFechaPublicacion"
                    className="accordion-collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionFechaPublicacion"
                  >
                    <button className="limpiar">Limpiar Filtro</button>
                    <div className="accordion-body">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="inlineCheckbox24"
                          value="24"
                          onChange={(e) => handleChangeFechaPublicacion(e)}
                          name="flexRadioDefault"
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox24"
                        >
                          Últimas 24 horas
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="inlineCheckbox3"
                          value="3"
                          onChange={(e) => handleChangeFechaPublicacion(e)}
                          name="flexRadioDefault"
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox3"
                        >
                          Hace 3 días
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="inlineCheckbox7"
                          onChange={(e) => handleChangeFechaPublicacion(e)}
                          name="flexRadioDefault"
                          value="7"
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox7"
                        >
                          Hace 7 días
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="inlineCheckbox14"
                          value="14"
                          onChange={(e) => handleChangeFechaPublicacion(e)}
                          name="flexRadioDefault"
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox14"
                        >
                          Hace 14 días
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="inlineCheckbox0"
                          value="0"
                          onChange={(e) => handleChangeFechaPublicacion(e)}
                          name="flexRadioDefault"
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox0"
                        >
                          Todas
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="accordion" id="accordionDepartamento">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseDepartamento"
                      aria-expanded="true"
                      aria-controls="collapseDepartamento"
                    >
                      Departamento
                    </button>
                  </h2>
                  <div
                    id="collapseDepartamento"
                    className="accordion-collapse  show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionDepartamento"
                  >
                    <button className="limpiar">Limpiar Filtro</button>
                    <div className="accordion-body">
                      {flagshowDepartamento === false
                        ? departmentList.slice(0, 7).map((item, index) => {
                            return (
                              <div key={index} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={
                                    "inlineCheckboxDepartamento" +
                                    item.departmentId
                                  }
                                  onChange={() => {
                                    handleDepartChange(item.departmentId);
                                  }}
                                  value={item.departmentId}
                                ></input>
                                <label
                                  className="form-check-label"
                                  htmlFor={
                                    "inlineCheckboxDepartamento" +
                                    item.departmentId
                                  }
                                >
                                  {item.name}
                                </label>
                              </div>
                            );
                          })
                        : departmentList.map((item, index) => {
                            return (
                              <div key={index} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={
                                    "inlineCheckboxDepartamento" +
                                    item.departmentId
                                  }
                                  onChange={() => {
                                    handleDepartChange(item.departmentId);
                                  }}
                                  value={item.departmentId}
                                ></input>
                                <label
                                  className="form-check-label"
                                  htmlFor={
                                    "inlineCheckboxDepartamento" +
                                    item.departmentId
                                  }
                                >
                                  {item.name}
                                </label>
                              </div>
                            );
                          })}

                      {departmentList.length > 7 &&
                      flagshowDepartamento === false ? (
                        <button
                          className="ver"
                          onClick={() => VerDepartamento(true)}
                        >
                          Ver más
                        </button>
                      ) : departmentList.length > 7 ? (
                        <button
                          className="ver"
                          onClick={() => VerDepartamento(false)}
                        >
                          Ver menos
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="accordion" id="accordionJornada">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseJornada"
                      aria-expanded="true"
                      aria-controls="collapseJornada"
                    >
                      Tipo de Jornada
                    </button>
                  </h2>
                  <div
                    id="collapseJornada"
                    //className="accordion-collapse collapse show"
                    className="accordion-collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionJornada"
                  >
                    <button className="limpiar">Limpiar Filtro</button>
                    <div className="accordion-body">
                      {tipojornadaList.map((item, index) => {
                        return (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={"inlineCheckboxJornada" + item.tipoJornadaId}
                              defaultChecked={false}
                              onChange={() => {
                                handleJornadaChange(item.tipoJornadaId);
                              }}
                              value={item.tipoJornadaId}
                            ></input>
                            <label
                              className="form-check-label"
                              htmlFor={
                                "inlineCheckboxJornada" + item.tipoJornadaId
                              }
                            >
                              {item.name}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="accordion" id="accordionContrato">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseContrato"
                      aria-expanded="true"
                      aria-controls="collapseContrato"
                    >
                      Tipo de Contrato
                    </button>
                  </h2>
                  <div
                    id="collapseContrato"
                    //className="accordion-collapse collapse show"
                    className="accordion-collapse  show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionContrato"
                  >
                    <button className="limpiar">Limpiar Filtro</button>
                    <div className="accordion-body">
                      {listContracts.map((item, index) => {
                        return (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={"inlineCheckboxContrato" + item.contractId}
                              defaultChecked={false}
                              onChange={() => {
                                handleContratoChange(item.contractId);
                              }}
                              value={item.contractId}
                            ></input>
                            <label
                              className="form-check-label"
                              htmlFor={
                                "inlineCheckboxContrato" + item.contractId
                              }
                            >
                              {item.name}
                            </label>
                          </div>
                        );
                      })}
                      {/* <button className="ver">Ver más</button> */}
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="accordion" id="accordionEmpleo">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEmpleo"
                      aria-expanded="true"
                      aria-controls="collapseEmpleo"
                    >
                      Tipo de Empleo
                    </button>
                  </h2>
                  <div
                    id="collapseEmpleo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionEmpleo"
                  >
                    <button
                      className="limpiar"
                      onClick={() => CleanFilterEmpleo()}
                    >
                      Limpiar Filtro
                    </button>
                    <div className="accordion-body">
                      {tipoempleoList.map((item, index) => {
                        return (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={"inlineCheckboxEmpleo" + item.typeEmployeeId}
                              defaultChecked={BuscarEmpleocheck(
                                item.typeEmployeeId
                              )}
                              onChange={() => {
                                handleEmpleoChange(item.typeEmployeeId);
                              }}
                              value={item.typeEmployeeId}
                            ></input>
                            <label
                              className="form-check-label"
                              htmlFor={
                                "inlineCheckboxEmpleo" + item.typeEmployeeId
                              }
                            >
                              {item.name}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="box">
              <div className="row justify-content-center p-5">
                <div className="text">Tus Resultados</div>
                <br />
                {listempleos.length === 0 ? (
                  <p className="title big">No se han encontrado resultado</p>
                ) : (
                  listempleos.map((item, index) => {
                    //console.log(item);
                    return (
                      <div
                        key={index}
                        id={"vacante" + index}
                        className="col-md-12 one-half"
                      >
                        <div className="head">
                          <div className="row">
                            <div className="col-md-2">
                              <div className=" box-img card-logo border-gray">
                                <img
                                  src={
                                    item.fotoPerfilEmpresa
                                      ? item.fotoPerfilEmpresa
                                      : defaultLogo
                                  }
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    redirectVacante(item.companyVacantId)
                                  }
                                ></img>
                                {/* <img src={item.fotoPerfilEmpresa}></img> */}
                                {/* <img src={cafe}></img> */}
                              </div>
                            </div>
                            <div className="col-md-7">
                              <div className="content">
                                <div
                                  className="cargo"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    redirectVacante(item.companyVacantId)
                                  }
                                >
                                  {item.cargo}
                                </div>
                                <div className="lugar">
                                  {item.nombreEmpresa}
                                </div>
                                <div className="cuidad">
                                  {item.departamento}
                                </div>
                              </div>
                            </div>
                            {!item.aplico ? (
                              <div className="col-md-3">
                                <div className="aplicar">
                                  <button
                                    className="btn btn--gradient"
                                    data-bs-toggle="modal"
                                    data-bs-target="#kr-modal"
                                    data-title="Experiencia"
                                    onClick={() =>
                                      aplicarVacante(item.companyVacantId)
                                    }
                                  >
                                    Aplicar
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="body">
                          <div className="left-side">
                            <ul>
                              <li>
                                <strong>Publicado:</strong>{" "}
                                {item.diasTranscurrdios}
                              </li>
                              <li>
                                <strong>Tipo:</strong> {item.tipoEmpleo}
                              </li>
                              <li>
                                <strong>Experiencia:</strong>{" "}
                                {item.nivelExperiencia}
                              </li>
                            </ul>
                          </div>
                          <div className="right-side">
                            <ul>
                              <li>
                                <i className="fa fa-eye" aria-hidden="true"></i>
                                <strong>Visualizaciones:</strong>{" "}
                                {item.visualizaciones}{" "}
                                <a
                                  onClick={() =>
                                    copyTextToClipboard(
                                      "/user/Vacante/" + item.companyVacantId
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-share-alt"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </li>
                              <li>
                                <i
                                  className="fa fa-folder-open"
                                  aria-hidden="true"
                                ></i>
                                <strong>Aplicando:</strong>{" "}
                                {item.cantidadAplicantes}{" "}
                                <a href="#">
                                  <i
                                    className="fa fa-bookmark"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="footer">
                          <div className="actitudes">
                            <div className="left-content col-8">
                              <strong>Aptitudes:</strong> 2 / 10
                              <span>
                                {item.listSkillVacante.map(
                                  (itemSkill, indexSkill) => {
                                    //console.log(index);
                                    return indexSkill ===
                                      item.listSkillVacante.length - 1
                                      ? itemSkill.habilidad
                                      : itemSkill.habilidad + " - ";
                                  }
                                )}
                              </span>
                            </div>
                            <div className="right-content col-4">
                              <a style={{ float: "right" }}>
                                Salario: {item.tipoMoneda} {item.salario}
                              </a>
                            </div>
                          </div>
                          <hr></hr>

                          {/* <div className="bottom-content">
                            <ul>
                              <li>
                                <a href="#">Pide una Recomendación</a>
                              </li>
                              <li>
                                <a href="#">Referir a contacto</a>
                              </li>
                              <li>
                                <a href="#">Pregúntanos</a>
                              </li>
                            </ul>
                          </div>*/}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
              {/* <div className="row justify-content-center">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-center pb-5">
                    <li className="page-item">
                      <a className="page-link" href="#">
                        Prev
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        3
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div
        id="kr-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu aplicación ha sido enviada exitosamente
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusquedaEmpleos;
